



























import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import Button from './Button.vue';
import ElemToConst from './forms/ElemToConst.vue';
import ConstToStar from './forms/ConstToStar.vue';
import ConstToAngles from './forms/ConstToAngles.vue';

@Component({
	components:{
		Button,
		ElemToConst,
		ConstToStar,
		ConstToAngles,
	}
})
export default class FormView extends Vue {

	private formIndex:number = -1;

	public mounted():void {
		
	}

	public beforeDestroy():void {
		
	}

}
